import {useLocale, useLogger} from '#imports';

export function useLanguageFormatter() {
    const {languageCode: displayLanguage} = useLocale();
    const logger = useLogger();

    function capitalizeFirstLetter(value: string): string {
        return value ? value[0].toUpperCase() + value.slice(1) : value;
    }

    function getLocalizedLanguageName(languageCode: string, defaultLanguageName?: string): string {
        try {
            if (languageCode && languageCode.length === 2) {
                const displayNames = new Intl.DisplayNames([displayLanguage.value], {
                    type: 'language',
                });
                const translatedValue = displayNames.of(languageCode) ?? languageCode;
                return capitalizeFirstLetter(translatedValue);
            }
        } catch (e) {
            logger.warn('Invalid language code: ', languageCode);
        }
        return defaultLanguageName ?? '';
    }

    return {
        getLocalizedLanguageName,
    };
}
